<template>
  <div class="short-description">
    <span class="title"> Описание </span>
    <!-- upperText убран для устранения дублирования слова "Описание" в мобильной версии -->
    <ul class="list">
      <li class="item" v-for="(item, index) in shortDescription.list" :key="index">{{ item }}</li>
    </ul>
    <div class="description" v-html="shortDescription.text" />
    <button v-if="false" @click="openFullDescription" class="button">
      <span class="text">Полное описание</span>
    </button>
    <!-- TODO: Replace with proper UI button component -->
  </div>
</template>

<script setup lang="ts">
// TODO: Replace with proper UI components when available
// import { ButtonUi } from '@mm-frontend/frontend-ui-kit';
// import { PopupsService, PopupsContainerModel } from '@/shared/popups';
// import Description from '../mobile/description.vue';

import type { IShortDescription } from '../../models/short-description';

interface Props {
  shortDescription: IShortDescription;
}

defineProps<Props>();

function openFullDescription() {
  // TODO: Replace with proper modal implementation
  console.log('TODO: openFullDescription - show description modal');

  // PopupsService.open({
  //   type: PopupsContainerModel.ETypeWrapper.SCREEN,
  //   component: Description,
  //   propsData: {
  //     title: 'Описание',
  //   },
  // });
}
</script>

<style lang="stylus" scoped>
.short-description
  font-family 'Inter'
  font-weight 400
  font-size 14px
  line-height 20px
  letter-spacing -0.005em
  color Gray(DK40)

  .description
    word-break break-word

  & > .title
    display none
    margin-bottom 24px
    font-size 22px
    font-weight 600
    line-height 28px
    letter-spacing -0.009em

    +Media(Mobile, Tablet)
      display inline

  .list
    margin 16px 0
    padding-left 16px
    list-style-type disc

    +Media(Mobile)
      padding-left 12px

    .item
      margin-bottom 12px
      word-break break-word

  .button
    display none
    margin-top 32px
    width 100%
    height 48px
    background-color #F5F6FA
    border 1px solid #E0E3E8
    border-radius 12px
    cursor pointer
    font-family Inter
    font-size 16px
    font-weight 500
    color #1F1F26
    transition all 0.2s ease
    align-items center
    justify-content center

    &:hover
      background-color #EAECF0

    +Media(Mobile, Tablet)
      display flex
</style>
